import { Link } from 'react-router-dom';
import { DocSection, Callout } from '../../../pages/shell';

export const toc = [
  { id: 'current', label: 'Current known issues' },
];

export default function Body() {
  return (
    <>
      <DocSection id="current" title="Current known issues">
        <p>
          An honest, running list — as of 2026-07-12 — of what's still rough around the edges.
          Nothing here is hidden; each item links to where it's covered in full.
        </p>

        <Callout kind="warn">
          <strong>Premiere panel's default docked size is too small.</strong> On first install the
          panel docks at roughly 240×300 pixels, which is cramped for real use. Drag the dock edge
          to widen it — Premiere remembers the new size for that dock. See{' '}
          <Link to="/docs/platforms/premiere-panel">The Adobe Premiere Pro panel</Link>.
        </Callout>

        <Callout kind="warn">
          <strong>The installer isn't code-signed.</strong> Every install and update shows a
          Windows SmartScreen "unknown publisher" warning — this is expected, not a sign of a bad
          download. Click <em>More info → Run anyway</em>. See{' '}
          <Link to="/docs/install#unknown-publisher">Download &amp; install</Link>.
        </Callout>

        <Callout kind="warn">
          <strong>Low VRAM can slow analysis a lot, not just a little.</strong> When even the
          smallest batch doesn't fit in free VRAM, Windows silently spills the work into system
          RAM — roughly 10× slower — instead of erroring. See{' '}
          <Link to="/docs/troubleshooting/gpu-not-detected#low-vram">Low-VRAM slowdowns</Link>.
        </Callout>

        <Callout kind="warn">
          <strong>Ultra Search falls back on tight cards.</strong> On lower-VRAM GPUs, Ultra either
          runs a reduced-accuracy "Lite" model or falls back to plain search rather than failing —
          the fallback is always shown, never silent. See{' '}
          <Link to="/docs/concepts/ultra-search#vram">Ultra Search: Ultra needs VRAM</Link>.
        </Callout>

        <Callout kind="warn">
          <strong>Face clustering occasionally splits one person into two groups.</strong> This is
          far more common than an incorrect merge. Use Merge in the People board to fold split
          groups back together. See{' '}
          <Link to="/docs/guides/find-and-name-people#merge">Merge groups &amp; review matching
          faces</Link>.
        </Callout>

        <Callout kind="tip">
          <strong>Crash reporting (Sentry) isn't active yet in this beta.</strong> The "Send crash
          reports & diagnostics" toggle exists in Settings, but no automatic crash reports are
          sent through it today — it will start working once it's wired up on our end, and this
          note will update when it does. The toggle still governs whether the diagnostics you
          attach to an in-app bug report get uploaded, so it's worth leaving on. In the meantime,
          the in-app bug report is the reliable way to reach us. See{' '}
          <Link to="/docs/concepts/local-and-private#diagnostics">Diagnostics & crash
          reporting</Link>.
        </Callout>

        <p>
          Fixed one of these already? Check{' '}
          <Link to="/docs/release-notes">Release notes</Link> before assuming it's still open.
        </p>
      </DocSection>
    </>
  );
}
